<template>
  <b-row
    v-if="breadcrumb"
    class="content-header"
  >

    <!-- Content Left -->
    <b-col
      class="content-header-left mb-1"
      cols="12"
      md="12"
    >
      <b-row class="breadcrumbs-top">
        <b-col cols="12">
<!--          <h2 class="content-header-title float-left pr-1 mb-0">-->
<!--            {{ $t(`navigation.${$route.meta.pageTitle}`)  }}-->
<!--          </h2>-->
          <div class="breadcrumb-wrapper">
            <b-breadcrumb>
              <b-breadcrumb-item to="/">
                <feather-icon
                  icon="HomeIcon"
                  size="16"
                  class="align-text-top"
                />
              </b-breadcrumb-item>

              <b-breadcrumb-item
                v-for="item in breadcrumb"
                :key="item.text"
                :active="item.active"
                @click="goToBread(item)"
                :active-class="'active'"

              >
<!--                {{item}}-->
              {{ item.translate ? $t(`navigation.${item.text}`) : item.text  }}
              <!-- {{$route.meta}} -->
                <!-- {{ item.text }} -->
              </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-col>
      </b-row>
    </b-col>

    <!-- Content Right -->
    <b-col
      class="content-header-right text-md-right d-none  d-none mb-1"
      md="3"
      cols="12"
    >
      <b-dropdown
        variant="link"
        no-caret
        toggle-class="p-0"
        right
      >

        <!-- <template #button-content>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="btn-icon"
          >
            <feather-icon icon="SettingsIcon" />
          </b-button>
        </template> -->

        <b-dropdown-item :to="{ name: 'apps-todo' }">
          <feather-icon
            icon="CheckSquareIcon"
            size="16"
          />
          <span class="align-middle ml-50">Todo</span>
        </b-dropdown-item>

        <b-dropdown-item :to="{ name: 'apps-chat' }">
          <feather-icon
            icon="MessageSquareIcon"
            size="16"
          />
          <span class="align-middle ml-50">Chat</span>
        </b-dropdown-item>

        <b-dropdown-item :to="{ name: 'apps-email' }">
          <feather-icon
            icon="MailIcon"
            size="16"
          />
          <span class="align-middle ml-50">Email</span>
        </b-dropdown-item>

        <b-dropdown-item :to="{ name: 'apps-calendar' }">
          <feather-icon
            icon="CalendarIcon"
            size="16"
          />
          <span class="align-middle ml-50">Calendar</span>
        </b-dropdown-item>
      </b-dropdown>
    </b-col>
  </b-row>
</template>

<script>
import {
  BBreadcrumb, BBreadcrumbItem, BRow, BCol, BDropdown, BDropdownItem, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from "@/store";

export default {
  directives: {
    Ripple,
  },
  computed:{
    breadcrumb() {
      return (typeof this.$route.meta.breadCrumb === 'function') ? this.$route.meta.breadCrumb(this.$route) : this.$route.meta.breadCrumb
    }
  },
  methods:{
    goToBread(item){
      if (item.to && this.$store.getters['breadcrumb/currentBreadcrumb'].filter(b => {
        return b.text === item.text
      }).length === 0){
        this.$router.push(item.to);
        // this.$store.commit('breadcrumb/REMOVE_CURRENT_BREADCRUMB');
        this.$store.commit('breadcrumb/SET_CURRENT_BREADCRUMB', [this.$store.getters['breadcrumb/breadcrumbs'][this.$store.getters['breadcrumb/breadcrumbs'].length-1]]);
        this.$store.commit('breadcrumb/REMOVE_FROM_INDEX', item);

      }
    }
  },
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BButton,
  },
}
</script>
